export default {
  map: {
    mapCoords: [55.755814, 37.617635],
    mapControls: ['zoomControl'],
    mapOptions: {
      suppressMapOpenBlock: true
    }
  }
};
